import React from 'react'
import './VaccinationPlan.css'
import portuguesCalendar from './portuguesCalendar.svg'
import deutchCalendar from './deutchlandCalendar.svg'
import brasilCalendar from './brasilCalendar.svg'
import withPolyglot from '../../common/withPolyglot'

const getCalendar = (locale) => {
  switch (locale) {
    case 'pt':
      return portuguesCalendar
    case 'de':
      return deutchCalendar
    case 'br':
      return brasilCalendar
    default:
      return portuguesCalendar
  }
}
const VaccinationPlan = ({translate, locale}) => {
  return <div className='vaccination-plan-container'>
    <img className='calendar uk-align-center' alt={translate('vaccinationPlan')} src={getCalendar(locale)} />
  </div>
}

export default withPolyglot(VaccinationPlan, 'vaccinationPlan')
